
export { ShoppingBagButton } from "/codebuild/output/src594262572/src/packages/shared-components/src/components/ShoppingBagButton/index.ts"